import React from "react";
import {Container, Card, Row, Col} from "react-bootstrap";
import Relic from "./Relic";
import { relics } from "../data/relics";

const Backpack = (props) => {

    const backpackRelics = JSON.parse(JSON.stringify(relics));

    const handleClickBackpackRelic = (relic) => {
        const relicInstance = JSON.parse(JSON.stringify(relic));
        const initialLevel = relicInstance.stats.hasOwnProperty('SS') ? 'SS' : Object.keys(relicInstance.stats)[0];
        props.setSelectedLevel(initialLevel);
        props.setSelectedRelic(relicInstance);
        props.setSelectionButtonText('Equip');
        if (!props.showSelection)
        {
            props.setShowSelection(true);
        }
    };

    return (
        <Container className="p-1">
            <div className="text-center">Backpack</div>
            <Card className="backpack p-0 m-0" style={{width: '210px', height: '350px'}}>
                <Card.Body className="holder pt-1 pb-1">
                <Row xs={3}>
                    {
                        backpackRelics.map((relic, index) => {
                            return (
                                <Col className="p-0" key={index} onClick={() => handleClickBackpackRelic(relic)}>
                                    <Relic relic={relic} ></Relic>
                                </Col>
                            )
                        })
                    }
                </Row>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Backpack;